import React, { memo } from 'react';
import AbsoluteEmpty from 'components/AbsoluteEmpty';
import { getLiteral } from 'utils/getLiteral';

const AutomationsListEmptyView = memo(() => {
    return (
        <div className="fm-automation-settings__empty-view">
            <AbsoluteEmpty
                title={getLiteral('label_history_empty_page')}
                subtitle={getLiteral('label_history_empty_page_desc')}
            />
        </div>
    );
});

export default AutomationsListEmptyView;
